import {forwardRef} from 'react';
import classNames from 'classnames';
import {useIntl} from 'react-intl';

import {Avatar} from '@time-webkit/all/atoms/avatar';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {ArchiveIcon} from '@time-webkit/all/icons/archive';

import type {BotSuggestionProps} from '../types';
import sharedStyles from '../styles.module.css';

export const BotSuggestion = forwardRef<HTMLDivElement, BotSuggestionProps>((props, ref) => {
    const intl = useIntl();
    const [headerTypography, loginTypography, unreadTypography, badgeTypography] = useTypography([
        {size: TypographySize.BodyL},
        {size: TypographySize.BodyM},
        {size: TypographySize.BodyXSTrue},
        {size: TypographySize.BodyXSSTrue},
    ]);

    return (
        <div
            data-test-id='botItem'
            ref={ref}
            onClick={props.onClick}
            className={classNames(sharedStyles.suggestion_container, props.className)}
        >
            <Avatar
                src={props.avatar}
                username={props.login}
                size={36}
            />
            <div className={sharedStyles.info_container}>
                <div className={sharedStyles.header_container}>
                    <span className={headerTypography}>{props.name}</span>
                    {props.deactivated && (
                        <ArchiveIcon
                            width={16}
                            height={16}
                            className={sharedStyles.icon}
                        />
                    )}
                    <div className={classNames(sharedStyles.badge, badgeTypography)}>
                        {intl.formatMessage({
                            id: 'post_info.bot',
                            defaultMessage: 'Bot',
                        })}
                    </div>
                </div>
                <div className={classNames(loginTypography, sharedStyles.description_container)}>
                    <span className={sharedStyles.login_text}>@{props.login} </span>
                    {props.deactivated && (
                        <span className={sharedStyles.description_text}>
                            ∙{' '}
                            {intl.formatMessage({
                                id: 'suggestion.user.deactivated',
                                defaultMessage: 'Deactivated',
                            })}
                        </span>
                    )}
                </div>
            </div>
            {Boolean(props.unreadCount) && (
                <div className={sharedStyles.unread_container}>
                    <div className={classNames(sharedStyles.unread, unreadTypography)}>{props.unreadCount}</div>
                </div>
            )}
        </div>
    );
});
